"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    cancel: {
        id: 'form.cancel',
        defaultMessage: 'Cancel',
    },
    reset: {
        id: 'form.reset',
        defaultMessage: 'Reset',
    },
    restore: {
        id: 'form.restore',
        defaultMessage: 'Restore Defaults',
    },
    submit: {
        id: 'form.submit',
        defaultMessage: 'Submit',
    },
    clear: {
        id: 'form.clear',
        defaultMessage: 'Clear',
    },
    placeholderName: {
        id: 'form.placeholder.name',
        defaultMessage: 'Please enter a name',
    },
});
//# sourceMappingURL=form.js.map